import { adminService } from './../services/admin.service'
import { appConstants } from "../constants/app.constants";
import { authService } from './../services/auth.service';
import {languageActions} from "./language.actions"
import {appActions} from "./app.actions"
import {store} from "../helpers/store"
import { useEffect,useSelector } from 'react';

export {
    // accountDetails,
    userDetails,
    updateMeterDetails,
    updateAccountDetails,
    accountsDetails
}
function userDetails() {
    return dispatch => {
        // dispatch(accountDetails())
        dispatch(accountsDetails())
        adminService.profileDetails().then(profileResponse => {
            dispatch(dispatchFormat(appConstants.PROFILE_DETAILS_SUCESS, profileResponse.data))
        }).catch(profileError => {
            dispatch(dispatchFormat(appConstants.PROFILE_DETAILS_ERROR, {
                email: '',
                firstName: '',
                lastName: '',
                phoneNumber: '',
                address: '',
                userName:''
            }))
        })
    }
}

// function accountDetails() {   
   
//     return dispatch => {
//             store.getState().snackbar = true; 
//         authService.accountDetais().then(accountInformation => { 
//             const getFirstMeter = (accountInformation.accountSummary.accountDetails) ? accountInformation.accountSummary.accountDetails.find(singleAcc => !singleAcc.isDisabled) : {};
//             dispatch(updateMeterDetails(getFirstMeter));
//             dispatch(dispatchFormat(appConstants.ACCOUNT_DETAILS_SUCESS, accountInformation.accountSummary))
//             store.getState().snackbar = false; 
//         }).catch(accountInfoError => {
//             store.getState().snackbar = true;
//             dispatch(dispatchFormat(appConstants.ACCOUNT_DETAILS_ERROR, {
//                 accountName: '',
//                 accountType: '',
//                 accountId: '',
//                 billingAddress: '',
//                 externalMeters: []
//             }))
//             store.getState().snackbar = false;
//         })
//    }
// }

function accountsDetails(){
    return dispatch=> {
        store.getState().snack = true;
        let accountInfo = {};
        let accountCloser = localStorage.getItem("accountSelected");
        let bearer = JSON.parse(localStorage.getItem("bearer"));
            if(bearer.accountDetails){
                accountInfo = bearer.accountDetails.accountSummary;
            }
        let data=accountInfo?.personAcccountDetail?.personAccountList
        let filterData= data.filter((item, k) => {
            if((item.accountSaList.length > 0)){
            return  item
            }
          })
        let getFirstMeter = accountInfo ? filterData.find(singleAcc => !singleAcc.isDisabled) : {};
        dispatch(dispatchFormat(appConstants.ACCOUNT_DETAILS_SUCESS, accountInfo));
        if (accountCloser) {
           data.forEach((single, k) => {
            if (Number(single?.customerNumber) === Number(accountCloser)) {
                dispatch(updateMeterDetails(single, single.accountSaList[0]));
              }
          });
          }else{
            dispatch(updateMeterDetails(getFirstMeter, getFirstMeter?.accountSaList[0]));
             localStorage.setItem("accountSelected",getFirstMeter?.customerNumber);
          }     
        store.getState().snackbar= false;
    }
}

function updateMeterDetails(meterInformation,saId) {
    const sampleObj= {getSaInfo:saId};
    meterInformation={...meterInformation,...sampleObj}
    return dispatch => {
        store.getState().snackbar = true; 
        dispatch(dispatchFormat(appConstants.UPDATE_OR_ADD_METER_DETAILS, meterInformation))
        store.getState().snackbar = false;
    }
}
function updateAccountDetails(accountDetails) {
    return dispatch => {
        store.getState().snackbar = true; 
        dispatch(dispatchFormat(appConstants.UPDATE_ACCOUNT_DETAILS, accountDetails))
        store.getState().snackbar = false;
    }
}
function dispatchFormat(actionType, snack) {
    return { type: actionType, snack };
}